import { CreditCard, Present, Save } from '@factorialco/f0-react/icons/app'
import { BankingValueObjectsCardCreationSourceEnum } from 'generated/resources/graphql'

export const icon = (creationSource: BankingValueObjectsCardCreationSourceEnum) => {
  switch (creationSource) {
    case 'expenses':
      return CreditCard
    case 'software':
      return Save
    case 'procurement':
      return CreditCard
    case 'salary':
      return Present
    default:
      return creationSource satisfies never
  }
}
